import { render, staticRenderFns } from "./OwnersList.vue?vue&type=template&id=21805e80&scoped=true&"
import script from "./OwnersList.vue?vue&type=script&lang=js&"
export * from "./OwnersList.vue?vue&type=script&lang=js&"
import style0 from "./OwnersList.vue?vue&type=style&index=0&id=21805e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21805e80",
  null
  
)

export default component.exports